import { esimPrivateApiClient } from "../api/EsimApiClient";

export const fetchInternalPackages = async ({ token, ...params }) => {
  const { filters = {}, ...restParams } = params;

  const cleanFilters = Object.fromEntries(
    Object.entries(filters).filter(
      ([_, value]) => value !== "" && value !== null && value !== undefined,
    ),
  );

  const queryParams = { ...restParams, ...cleanFilters };

  const response = await esimPrivateApiClient.get("/internal/batch", {
    params: queryParams,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return {
    total: response.data.total_records,
    filtered: response.data.filtered_records,
    items: response.data.items,
  };
};
